import React, { useReducer } from "react";
import PropTypes from "prop-types";
import reducer from "./reducer";
import * as appConfigActionsTypes from "./actionsTypes";

const AppConfigContext = React.createContext();

AppConfigContext.displayName = "AppConfigContext";

const initialState = {
  adProductSplashScreen: {
    seen: false,
    visible: false,
  },
  toasts: {
    logout: false,
  },
};

function AppConfigProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = [state, dispatch];
  return (
    <AppConfigContext.Provider value={value}>
      {children}
    </AppConfigContext.Provider>
  );
}

function useAppConfig() {
  const context = React.useContext(AppConfigContext);
  if (context === undefined) {
    throw new Error("You forgot to wrap your app in a AppConfigProvider");
  }
  return context;
}

AppConfigProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

AppConfigProvider.defaultProps = {
  children: undefined,
};

export { useAppConfig, AppConfigProvider, appConfigActionsTypes };
